export const city_default_links = {
  ru: {
    1: 'https://drive.usercontent.google.com/download?id=1g0CgJKMCF8aDwMfjrk8aNY05tIgucIg_&export=download',
    2: 'https://drive.google.com/uc?export=download&id=1RQQ0Z4XwJPq6v1UrBNoyoeV7wElSgOtR',
    5: 'https://drive.google.com/uc?export=download&id=1HOkD2g8Vnd58miql4tOb-bWlJrcZgn3J',
    3: 'https://drive.google.com/uc?export=download&id=1esCMFOnXH-idXvvHWn116W0Y3Y2Fpecr',
    4: 'https://drive.google.com/uc?export=download&id=1yZK6vEYzdjzM5jkhLEDJxGOCPHS3AdPr',
  },
  en: {
    1: 'https://drive.google.com/uc?export=download&id=1yBrhzIH-rGziTrdxMD3EuI6Nogvf8ztQ',
    2: 'https://drive.google.com/uc?export=download&id=1R7LWZFuOSFYJDU_O53eriXpTuFHFn5ae',
    5: 'https://drive.google.com/uc?export=download&id=13YaJ4MBqAe0P__A6x5roTyjubddRzjtu',
    3: 'https://drive.google.com/uc?export=download&id=1ezjAMuR25PZ091lg5AetEIs4p162J85X',
    4: 'https://drive.google.com/uc?export=download&id=1rwdrVIVKPtexAgOFHc7jzD6m3lcaGNTd',
  },
};
